import { v2Request } from './client';

/** Submit contact form enquiry to Pilot API. */
export async function submitCustomerEnquiry(data) {
  return v2Request('/api/newCustomerEnquiry', {
    method: 'POST',
    body: data,
  });
}
